import { combineReducers } from 'redux'

import isDialogOpen from './isDialogOpen'
import uniqueAIObjectId from './uniqueAIObjectId'

export default combineReducers({
  isDialogOpen,
  uniqueAIObjectId,
})
